import { api } from '../axiosClient';
import { ConfigurationFeaturesResponse } from './configurationFeatures.types';

const CONFIGURATION_FEATURES_PATH = '/Configuration/features';

export const getConfigurationFeatures =
  (): Promise<ConfigurationFeaturesResponse> => {
    return api.get(CONFIGURATION_FEATURES_PATH);
  };
